import { track } from '@turfchale/analytics'
import { X } from 'lucide-react'
import { useEffect, useState } from 'react'

import { useInstallPrompt } from '../../hooks/useInstallPrompt'

export function InstallBanner() {
  const { canInstall, install } = useInstallPrompt()
  const [visible, setVisible] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (canInstall && !dismissed) {
      const t = setTimeout(() => {
        setVisible(true)
        track('pwa_install_prompted')
      }, 3500)
      return () => clearTimeout(t)
    }
  }, [canInstall, dismissed])

  if (!visible) return null

  return (
    <div
      className="fixed bottom-5 left-1/2 z-50 flex items-center gap-3 px-4 py-3 rounded-2xl shadow-xl transition-all duration-300"
      style={{
        background: 'var(--bg3)',
        border: '1px solid var(--lime-line)',
        maxWidth: 'min(380px, calc(100vw - 2rem))',
        transform: 'translateX(-50%)',
        width: '100%',
      }}
    >
      <div
        className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 font-display font-bold text-base"
        style={{ background: 'var(--lime)', color: 'var(--bg)' }}
      >
        TC
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold" style={{ color: 'var(--text)' }}>
          Install TurfChale
        </p>
        <p className="text-xs" style={{ color: 'var(--muted)' }}>
          Add to home screen for the best experience
        </p>
      </div>
      <button
        className="shrink-0 text-xs font-bold px-4 py-1.5 rounded-full transition-opacity hover:opacity-85"
        onClick={() => {
          track('pwa_install_accepted')
          install()
        }}
        style={{ background: 'var(--lime)', color: 'var(--bg)' }}
      >
        Install
      </button>
      <button
        aria-label="Dismiss"
        className="shrink-0 p-1 transition-colors"
        onClick={() => {
          track('pwa_install_dismissed')
          setVisible(false)
          setDismissed(true)
        }}
        style={{ color: 'var(--muted)' }}
      >
        <X size={16} />
      </button>
    </div>
  )
}
